import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    textAlign: "left",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  header: {
    padding: theme.spacing(1.25),
    alignItems: "center",
  },
  closeButton: {
    padding: 0,
  },
  closeButtonIcon: {
    width: "20px",
    height: "20px",
  },
  statusButtons: {
    width: "100%",
    justifyContent: "flex-start",
  },
  statusDots: {
    borderRadius: "9999px",
    height: "15px",
    width: "15px",
    marginRight: theme.spacing(1.25),
  },
  selected: {
    backgroundColor: `${theme.palette.blue.main} !important`,
    borderRadius: "5px !important",
  },
  activeStatusDot: {
    backgroundColor: theme.palette.success.dark,
  },
  awayStatusDot: {
    backgroundColor: theme.palette.warning.dark,
  },
  focusingStatusDot: {
    backgroundColor: theme.palette.error.main,
  },
  statusButtonContent: {
    fontWeight: 500,
    alignItems: "center",
    padding: `0px ${theme.spacing(1)}`,
    color: theme.palette.text.secondary,
  },
  checkIcon: {
    height: "18px",
    width: "18px",
    marginRight: theme.spacing(1),
  },
  input: {
    marginTop: theme.spacing(1),
  },
}));
